module.exports = __webpack_public_path__ + "static/img/Indent.6de3217.gif";